module.exports = __webpack_public_path__ + "img/icon-02.60ecd760.svg";